import { redirectToPage } from "@client/actions";
import Image from "@client/controls/Image/container";
import Link from "@client/controls/Link/container";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { pagesHomePageIdSelector } from "@client/selectors";
import { type LogoOptions } from "@client/types";
import classnames from "classnames";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { type ThunkDispatch } from "redux-thunk";

export interface LogoProps {
  preventRedirect: boolean;
  options: LogoOptions | null;
}

const Logo = ({ options, preventRedirect }: LogoProps) => {
  const homePageId = useSelector(pagesHomePageIdSelector);

  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const onClick = React.useCallback(
    () => !preventRedirect && dispatch(redirectToPage(homePageId)),
    [preventRedirect, homePageId]
  );

  if (!options?.fileSrc) return null;

  return (
    <div className={classnames("logo", `logo-${options.position}`)}>
      <Link title={options.title} onClick={onClick}>
        <Image src={options.fileSrc} alt={options.title} style={options.style} />
      </Link>
    </div>
  );
};
export default withIsVisibleHOC(Logo);

export const INVISIBLE_PROPS: LogoProps & WithIsVisibleHOCProps = {
  options: null,
  isVisible: false,
  preventRedirect: false
};
